import { Injectable } from '@angular/core';

import {
    PcvizBaseWorkflowClass,
    PcvizScanWorkflow,
    PcvizGenericWorkflow,
    PcvizProcessScans,
    PcvizScanConstans,
    PcvizWorkflowServiceRegistry,
    WorkflowType,
    ScanTask,
    GenericTask,
    PcvizWorkflow,
    PcvizProcessScansConstructor,
    PcvizC2CConstructor,
    PcvizReportC2CConstructor,
} from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class WorkflowPcvizService {
    /* istanbul ignore next */
    getWorkflowClass(): PcvizBaseWorkflowClass {
        return this.getWorkflow().Workflow;
    }

    /* istanbul ignore next */
    getScanWorkflow(): PcvizScanWorkflow {
        return this.getWorkflow().ScanWorkflow;
    }

    /* istanbul ignore next */
    getGenericWorkflow(): PcvizGenericWorkflow {
        return this.getWorkflow().GenericWorkflow;
    }

    /* istanbul ignore next */
    getC2C(): PcvizC2CConstructor {
        return this.getWorkflow().C2C;
    }

    /* istanbul ignore next */
    getReportC2C(): PcvizReportC2CConstructor {
        return this.getWorkflow().ReportC2C;
    }

    /* istanbul ignore next */
    getProcessScans(): PcvizProcessScans {
        return this.getWorkflow().ProcessScans as PcvizProcessScans;
    }

    /* istanbul ignore next */
    getScanConstants(): PcvizScanConstans {
        return this.getWorkflow().ScanConstants;
    }

    /* istanbul ignore next */
    getProcessScansClass(): PcvizProcessScansConstructor {
        return this.getWorkflow().ProcessScans as PcvizProcessScansConstructor;
    }

    getWorkflowServiceRegistry(): PcvizWorkflowServiceRegistry {
        return PointCloudViz.Workflow.WorkflowServiceRegistry;
    }

    /* istanbul ignore next */
    registerService(name: WorkflowType, service: any): void {
        this.getWorkflowServiceRegistry().registerService(name, service);
    }

    /* istanbul ignore next */
    /**
     * @deprecated This method is deprecated. Using the service stored in WorkflowRegistrationService
     */
    getServiceFromCore(workflowType: WorkflowType): any {
        return this.getWorkflowServiceRegistry().getInstance().getService(workflowType);
    }

    /* istanbul ignore next */
    getScanTasks(): ScanTask {
        return this.getWorkflow().ScanConstants.getScanTasks();
    }

    /* istanbul ignore next */
    getGenericTasks(): GenericTask {
        return this.getWorkflow().GenericConstants.getGenericTasks();
    }

    private getWorkflow(): PcvizWorkflow {
        return PointCloudViz.Workflow;
    }
}
